import React from 'react';
import { SolutionInstallationsModalExtensionProps } from 'SolutionCatalog/SolutionInstallationsModal/Modal';

const LazySolutionInstallationsModal = React.lazy(
	() => import('../SolutionCatalog/SolutionInstallationsModal/Modal')
);

export const SolutionInstallationsModal: React.FC<
	SolutionInstallationsModalExtensionProps
> = props => {
	return (
		<React.Suspense fallback={<div data-testid="loading-solution-installations-modal" />}>
			<LazySolutionInstallationsModal {...props} />
		</React.Suspense>
	);
};
